import { rootAPI } from 'apis/catalog';

import type { CustomSizePriceData } from 'types/catalog_types';

export const getCustomSizePrice = async (w: number, h: number, billingCode: string) => {
  // sanitize billing code
  const bc = billingCode.replace('/', '%2F');

  // no billing code?
  if (bc === '_') {
    return { cost: 0 };
  }

  const { data } = await rootAPI.get<CustomSizePriceData>(
    `/custom_size_price/calculate/${w}/${h}/${bc}.json`
  );

  return data;
};
